import {
  Button,
  Card,
  CardContent,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { Delete, Edit } from "@material-ui/icons";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  deleteApplicationReferral,
  fetchApplicationReferrals,
} from "../../../../services/applicationReferral";
import {
  fetchReferralForFlowStatus,
  fetchReferralPdf,
} from "../../../../services/flowApplicationStatusService";

import { Buffer } from "buffer";
import CreateReferralPdfDialog from "./CreateReferralPdfDialog";
import CustomAlert from "../../../components/CustomAlert";
import CustomTable from "../../../../components/GovGrMaterialTable";
import DeleteDialog from "../../../components/CustomDeleteDialog";
import UpdateDialog from "./UpdateDialog";
import UploadDialog from "./UploadDialog";
import useLocale from "../../../../hooks/useLocale";
import { useQuery } from "react-query";
import { fetchApplicationDocuments } from "../../../../services/applicationDocuments";
import { PSIFIAKIFOTOGRAFIAID } from "../../../../constants";
import hellenicFlag from "../../../../staticImages/hellenicEmblem.jpg";
import useStaticFiles from "../../../../hooks/useStaticFiles";
import GovGrButton from "../../../../components/GovGrButton";
import GovGrCard from "../../../../components/GovGrCard";

const useStyles = makeStyles({
  root: {
    "& .MuiTextField-root": {
      margin: 15,
    },
    "& .MuiInputBase-root.Mui-disabled": {
      color: "rgba(0, 0, 0, 1)", // (default alpha is 0.38)
    },
  },
  card: {
    minWidth: 275,
    marginTop: 15,
    marginBottom: 15,
    alignSelf: "center",
  },
  uploadBtn: {
    marginTop: "1.4rem",
    marginBottom: "1.4rem",
  },
  btnSpace: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  viewDetails: {
    width: 700,
    height: 400,
  },
});
// const DarkerDisabledTextField = withStyles({
//   root: {
//     marginTop: 15,
//     marginBottom: 15,
//     "& .MuiInputBase-root.Mui-disabled": {
//       color: "rgba(0, 0, 0, 1)", // (default alpha is 0.38)
//     },
//   },
// })(TextField);

const ApplicantReferrals = React.memo(({ values, id, flowId, viewOnly }) => {
  const { t } = useLocale();
  const classes = useStyles();

  const [referrals, setReferrals] = useState([]);
  const [selectedItem, setSelectedItem] = useState({});
  const [isUploadDialogOpen, setIsUploadDialogOpen] = useState(false);
  const [isUpdateDialogOpen, setIsUpdateDialogOpen] = useState(false);
  const [isCreateReferralDialogOpen, setisCreateReferralDialogOpen] =
    useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [pictureForEditor, setPictureForEditor] = useState("");
  // const [urlFlag, setUrlFlag] = useState("");

  const { urlFlag } = useStaticFiles();

  const {
    data: ApplicationReferrals,
    isError: isErrorApplicationReferral,
    isLoading: isLoadingApplicationReferral,
    refetch: refetchApplicationReferral,
  } = useQuery(["applicationReferralsWithId", id], () =>
    fetchApplicationReferrals(id)
  );
  const { data: refsForFlow } = useQuery(
    ["referralsForFlowStatus", flowId, values?.appl_kind_id],
    () => fetchReferralForFlowStatus(flowId, values?.appl_kind_id)
  );

  const {
    data: documents,
    isError,
    isLoading,
    refetch,
  } = useQuery(["applicationDocumentsWithId", id], () =>
    fetchApplicationDocuments(id)
  );

  // Get the document with the picture for Editor
  const pictureForReferral = documents?.find(
    (doc) => doc?.doc_id === PSIFIAKIFOTOGRAFIAID
  );

  // Create pictureData for adding them to Pdf
  const pictureSrc = window.btoa(
    String.fromCharCode(...new Uint8Array(pictureForReferral?.doc_data?.data))
  );

  // Create url of applicantImage for adding it to Editor
  const byteArray = new Uint8Array(pictureForReferral?.doc_data?.data);
  const blob = new Blob([byteArray], {
    type: pictureForReferral?.content_type,
  });
  let urlImageApplicant = window.URL.createObjectURL(blob);

  useEffect(() => {
    setReferrals(
      refsForFlow?.filter(
        (elem) =>
          !ApplicationReferrals?.find(
            ({ referral_kind_id }) => elem?.id === referral_kind_id
          )
      )
    );
  }, [refsForFlow, ApplicationReferrals]);

  return (
    <>
      <div className={classes.root}>
        <GovGrCard>
          <Typography variant="h3" color="textPrimary" gutterBottom>
            {t("Referrals")}
          </Typography>
          <div>
            <CustomAlert
              open={isErrorApplicationReferral}
              close={() => {
                refetchApplicationReferral();
              }}
              message={t("A network error occured, please try again later")}
            />

            <div className={classes.btnSpace}>
              <GovGrButton
                disabled={referrals?.length === 0 ? true : false}
                onClick={() => setisCreateReferralDialogOpen(true)}
                variant="primary"
                buttonText={t("Referrals creation")}
              />

              <GovGrButton
                disabled={referrals?.length === 0 ? true : false}
                onClick={() => setIsUploadDialogOpen(true)}
                variant="primary"
                buttonText={t("Upload referral")}
              />
            </div>

            <CustomTable
              options={{
                showTitle: false,
                search: false,
              }}
              isLoading={isLoadingApplicationReferral}
              columns={[
                {
                  title: t("Referral"),
                  field: "referral",
                },
                {
                  title: t("Filename"),
                  field: "file_name",
                },
                {
                  title: t("File type"),
                  field: "content_type",
                },
                {
                  title: t("File"),
                  field: "referral_doc",
                  render: (rowData) => {
                    return (
                      <GovGrButton
                        onClick={() => {
                          const blob = new Blob(
                            [Buffer.from(rowData?.referral_doc?.data)],
                            { type: rowData?.content_type }
                          );
                          let url = window.URL.createObjectURL(blob);

                          window.open(url, "_blank");
                          //let a = document.createElement("a");
                          //a.href = url;
                          //a.download = rowData?.file_name;
                          //a.click();
                        }}
                        variant="secondary"
                        buttonText={t("View")}
                      />
                    );
                  },
                },
              ]}
              data={ApplicationReferrals}
              editLabel={t("Edit")}
              deleteLabel={t("Delete")}
              onEdit={(event, rowData) => {
                setIsUpdateDialogOpen(true);
                setSelectedItem(rowData);
              }}
              onDelete={(event, rowData) => {
                setIsDeleteDialogOpen(true);
                setSelectedItem(rowData);
              }}
            />
          </div>
        </GovGrCard>
        <UploadDialog
          open={isUploadDialogOpen}
          close={() => setIsUploadDialogOpen(false)}
          refetch={refetchApplicationReferral}
          appl_id={id}
          values={values}
          flowId={flowId}
        />
        <UpdateDialog
          open={isUpdateDialogOpen}
          close={() => setIsUpdateDialogOpen(false)}
          refetch={refetchApplicationReferral}
          appl_id={id}
          selectedItem={selectedItem}
        />
        <DeleteDialog
          title={t("Delete Application Kind")}
          message={t(
            "Are you sure you want to delete the selected Application Referral"
          )}
          fieldName="referral"
          open={isDeleteDialogOpen}
          close={() => setIsDeleteDialogOpen(false)}
          refetch={refetchApplicationReferral}
          selectedItem={selectedItem}
          deleteService={deleteApplicationReferral}
        />
        {refsForFlow ? (
          <CreateReferralPdfDialog
            open={isCreateReferralDialogOpen}
            close={() => setisCreateReferralDialogOpen(false)}
            id={id}
            flowId={flowId}
            applicationKindId={values?.appl_kind_id}
            pictureSrc={pictureSrc} // base64 of image
            urlImageApplicant={urlImageApplicant} // blob of imageApplicant
            urlFlag={urlFlag} // blob of flagUrl
          />
        ) : null}
      </div>
    </>
  );
});

export default ApplicantReferrals;
